import styled from "styled-components";
import {T} from "../Chat/connector";
import {Tooltip} from "antd";


export const FullUserVideo = (props) => {
    return (
        <FullUserVideoStyle className={props?.className}>
            <div className="name">
                <span>
                    {props?.user?.name}
                    {props?.user?.isAudioAvailable === false ? (
                        <div className={'is-muted'}><MuteOffIcon/></div>) : null}
                </span>
            </div>
            <div className="video-container" id={props.id}>
                <video autoPlay playsInline muted/>
            </div>
        </FullUserVideoStyle>
    );
}

const FullUserVideoStyle = styled.div`
    position: relative;
    flex: 1;
    width: 100%;
    height: 100%;

    .video-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;

        video {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 1;
            object-fit: contain !important;
        }
    }

    .name {
        background: linear-gradient(180deg, #000 3.33%, rgba(0, 0, 0, 0.00) 100%);
        height: 150px;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: flex;

        span {
            color: #FFF;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            margin: 16px;
            display: inline-flex;
            height: 24px;
            align-items: center;
            line-height: 24px;
        }

        .is-muted {
            display: inline-block;
            margin-left: 12px;
            width: 20px;
            height: 20px;

            svg {
                fill: white;
            }
        }
    }
`;

export const UserCards = styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 10;
    height: 100%;
    overflow: auto;
    padding-bottom: 16px;
`;

export const UserCard = (props: any) => {
    const cameraId = `camera-${props?.user?.userID}`;

    return (
        <Tooltip title={props?.user?.name}>
            <UserCardStyle onClick={props?.onClick} className={props?.className}>
                <div className="avatar" style={{display: props?.user?.isVideoAvailable ? 'none' : 'flex'}}>
                    {
                        props?.user?.avatar && !props?.user?.avatar.toString().includes('null.png') ? (
                            <img src={props?.user?.avatar} alt={props?.user?.name}/>
                        ) : (
                            <DefaultAvatarIcon/>
                        )
                    }
                </div>
                <div className={'video'} id={cameraId} style={{opacity: (props.user?.isVideoAvailable ? 1 : 0)}}/>
                <div className={`name ${props?.user?.isVideoAvailable ? 'has-video' : ''}`}>
                    <span>{props?.user?.name}</span>
                </div>
                {props?.user?.isAudioAvailable === false ? (<div className={'is-muted'}><MuteOffIcon/></div>) : null}
            </UserCardStyle>
        </Tooltip>
    );
}

const UserCardStyle = styled.div`
    display: flex;
    width: 90px;
    height: 112px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    border-radius: 10px;
    border: 1px solid #FFF;
    background: #FF9E3E;
    margin-bottom: 9px;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    &.card-style-0 {
        background-color: #FF9E3E;
    }

    &.card-style-1 {
        background-color: #F45D51;
    }

    &.card-style-2 {
        background-color: #6574E0;
    }

    &.card-style-3 {
        background-color: #00ae03;
    }

    &.card-style-4 {
        background-color: #d6a6ff;
    }

    &.card-style-5 {
        background-color: #87bc88;
    }

    &.card-style-6 {
        background-color: #63c9ff;
    }

    &.card-style-7 {
        background-color: #44e1b1;
    }

    &.card-style-8 {
        background-color: #84bc84;
    }

    &.card-style-9 {
        background-color: rgba(202, 39, 131, 0.35);
    }

    &.card-style-invite {
        background-color: #1D896D;
    }

    .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        position: absolute;
        top: calc(50% - 16px);
        left: calc(50% - 16px);
        z-index: 1;
    }

    .avatar img, .avatar svg {
        width: 32px;
        height: 32px;
    }

    .avatar img {
        border-radius: 16px;
    }

    .name {
        overflow: hidden;
        color: #FFF;

        height: 45px;
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: 100%;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;
        padding-bottom: 8px;

        &.has-video {
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
        }

        span {
            display: block;
            width: calc(100% - 24px);
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            text-align: center;
            text-overflow: ellipsis;
            line-height: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
    }

    .video {
        width: 100%;
        height: 100%;
        flex: 1;
        z-index: 2;

        video {
            object-fit: contain !important;
        }
    }

    .is-muted {
        font-size: 11px;
        position: absolute;
        top: 6px;
        right: 6px;
        z-index: 2;
        width: 16px;
        height: 16px;
        color: white;

        svg {
            fill: white;
        }
    }
`;

export const FullUserProfile = (props: {
    mode?: 'small' | 'large';
    user?: {
        name: string;
        avatar: string;
        isAudioAvailable?: boolean;
    };
}) => {
    return (
        <ProfileStyle>
            {props?.user?.isAudioAvailable === false ? (
                <div className={'is-muted'}><MuteOffIcon/></div>) : null}
            <div className="avatar">
                {
                    props?.user?.avatar && !props?.user?.avatar.toString().includes('null.png') ? (
                        <img src={props?.user?.avatar} alt={props?.user?.name}/>
                    ) : (
                        <DefaultAvatarIcon/>
                    )
                }
            </div>
            <div className="name">
                {props?.user?.name}

            </div>
        </ProfileStyle>
    );
}

export const InviteButton = (props) => {
    return (
        <UserCardStyle onClick={props?.onClick} className={props?.className}>
            <div className="avatar">
                <InviteIcon/>
            </div>
            <div className="name">
                <span>{T("Invite")}</span>
            </div>
        </UserCardStyle>
    );
}

const ProfileStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .avatar {
        display: flex;
        width: 120px;
        height: 120px;
        align-items: center;
        margin-bottom: 12px;
    }

    .avatar img, .avatar svg {
        width: 120px;
        height: 120px;
    }

    .avatar img {
        border-radius: 60px;
    }

    .name {
        color: #FFF;
        font-size: 40px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: center;
    }

    .is-muted {
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 2;
        width: 24px;
        height: 24px;

        svg * {
            fill: #FFFFFF;
            stroke: #FFFFFF;
        }
    }
`;

const DefaultAvatarIcon = (props) => (
    <svg {...props} width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="120" rx="60" fill="white" fillOpacity="0.16"/>
        <g clipPath="url(#clip0_3229_15442)">
            <mask id="mask0_3229_15442" maskUnits="userSpaceOnUse" x="32" y="32" width="56"
                  height="56">
                <path d="M88 32H32V88H88V32Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_3229_15442)">
                <path
                    d="M60 60C66.4432 60 71.6666 54.7767 71.6666 48.3334C71.6666 41.89 66.4432 36.6667 60 36.6667C53.5567 36.6667 48.3333 41.89 48.3333 48.3334C48.3333 54.7767 53.5567 60 60 60Z"
                    fill="white"/>
                <path
                    d="M59.9998 65.8334C48.3098 65.8334 38.7898 73.6734 38.7898 83.3334C38.7898 83.9867 39.3031 84.5 39.9565 84.5H80.0431C80.6964 84.5 81.2098 83.9867 81.2098 83.3334C81.2098 73.6734 71.6898 65.8334 59.9998 65.8334Z"
                    fill="white"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_3229_15442">
                <rect width="56" height="56" fill="white" transform="translate(32 32)"/>
            </clipPath>
        </defs>
    </svg>
)
const MuteOffIcon = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32"
              d="M432 400L96 64"/>
        <path
            d="M400 240v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 208v32a111.68 111.68 0 01-2.68 24.38 2 2 0 00.53 1.84l22.59 22.59a2 2 0 003.29-.72A143.27 143.27 0 00400 240zM256 352a112.36 112.36 0 01-112-112v-31.55c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 208v32c0 74 56.1 135.12 128 143.11V432h-47.55c-8.61 0-16 6.62-16.43 15.23A16 16 0 00192 464h127.55c8.61 0 16-6.62 16.43-15.23A16 16 0 00320 432h-48v-48.89a143.08 143.08 0 0052-16.22 4 4 0 00.91-6.35l-18.4-18.39a3 3 0 00-3.41-.58A111 111 0 01256 352zM257.14 48a79.66 79.66 0 00-68.47 36.57 4 4 0 00.54 5L332.59 233a2 2 0 003.41-1.42V128.91C336 85 301 48.6 257.14 48z"/>
        <path
            d="M179.41 215a2 2 0 00-3.41 1.42V239a80.89 80.89 0 0023.45 56.9 78.55 78.55 0 0077.8 21.19 2 2 0 00.86-3.35z"/>
    </svg>
);

const InviteIcon = (props) => (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_3535_448" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
            <path d="M32 0.5H0V32.5H32V0.5Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_3535_448)">
            <path
                d="M29.2933 3.60665C28.3333 2.51331 26.9067 1.83331 25.3333 1.83331C23.84 1.83331 22.48 2.44665 21.5067 3.44665C20.9467 4.01998 20.52 4.71331 20.2667 5.48665C20.0933 6.01998 20 6.57998 20 7.16665C20 8.16665 20.28 9.11331 20.7733 9.91331C21.04 10.3666 21.3867 10.78 21.7867 11.1266C22.72 11.98 23.96 12.5 25.3333 12.5C25.92 12.5 26.48 12.4066 27 12.22C28.2267 11.8333 29.2533 10.9933 29.8933 9.91331C30.1733 9.45998 30.3867 8.93998 30.5067 8.40665C30.6133 8.00665 30.6667 7.59331 30.6667 7.16665C30.6667 5.80665 30.1467 4.55331 29.2933 3.60665ZM27.32 8.13998H26.3333V9.17998C26.3333 9.72665 25.88 10.18 25.3333 10.18C24.7867 10.18 24.3333 9.72665 24.3333 9.17998V8.13998H23.3467C22.8 8.13998 22.3467 7.68665 22.3467 7.13998C22.3467 6.59331 22.8 6.13998 23.3467 6.13998H24.3333V5.19331C24.3333 4.64665 24.7867 4.19331 25.3333 4.19331C25.88 4.19331 26.3333 4.64665 26.3333 5.19331V6.13998H27.32C27.8667 6.13998 28.32 6.59331 28.32 7.13998C28.32 7.68665 27.88 8.13998 27.32 8.13998Z"
                fill="white"/>
            <path
                d="M29.3334 16.5C29.3334 14.7533 29 13.0733 28.3734 11.54C27.96 11.8333 27.4934 12.06 27 12.22C26.8534 12.2733 26.7067 12.3133 26.5467 12.3533C27.0534 13.6333 27.3334 15.0333 27.3334 16.5C27.3334 19.5933 26.08 22.4066 24.0534 24.46C23.6667 23.9666 23.1734 23.5133 22.5867 23.1266C18.9734 20.7 13.0534 20.7 9.41335 23.1266C8.82669 23.5133 8.34669 23.9666 7.94669 24.46C5.92002 22.4066 4.66669 19.5933 4.66669 16.5C4.66669 10.2466 9.74669 5.16663 16 5.16663C17.4534 5.16663 18.8534 5.44663 20.1334 5.95329C20.1734 5.79329 20.2134 5.64663 20.2667 5.48663C20.4267 4.99329 20.6534 4.53996 20.96 4.12663C19.4267 3.49996 17.7467 3.16663 16 3.16663C8.65335 3.16663 2.66669 9.15329 2.66669 16.5C2.66669 20.3666 4.33335 23.8466 6.97335 26.2866C6.97335 26.3 6.97335 26.3 6.96002 26.3133C7.09335 26.4466 7.25335 26.5533 7.38669 26.6733C7.46669 26.74 7.53335 26.8066 7.61335 26.86C7.85335 27.06 8.12002 27.2466 8.37335 27.4333C8.46669 27.5 8.54669 27.5533 8.64002 27.62C8.89335 27.7933 9.16002 27.9533 9.44002 28.1C9.53335 28.1533 9.64002 28.22 9.73335 28.2733C10 28.42 10.28 28.5533 10.5734 28.6733C10.68 28.7266 10.7867 28.78 10.8934 28.82C11.1867 28.94 11.48 29.0466 11.7734 29.14C11.88 29.18 11.9867 29.22 12.0934 29.2466C12.4134 29.34 12.7334 29.42 13.0534 29.5C13.1467 29.5266 13.24 29.5533 13.3467 29.5666C13.72 29.6466 14.0934 29.7 14.48 29.74C14.5334 29.74 14.5867 29.7533 14.64 29.7666C15.0934 29.8066 15.5467 29.8333 16 29.8333C16.4534 29.8333 16.9067 29.8066 17.3467 29.7666C17.4 29.7666 17.4534 29.7533 17.5067 29.74C17.8934 29.7 18.2667 29.6466 18.64 29.5666C18.7334 29.5533 18.8267 29.5133 18.9334 29.5C19.2534 29.42 19.5867 29.3533 19.8934 29.2466C20 29.2066 20.1067 29.1666 20.2134 29.14C20.5067 29.0333 20.8134 28.94 21.0934 28.82C21.2 28.78 21.3067 28.7266 21.4134 28.6733C21.6934 28.5533 21.9734 28.42 22.2534 28.2733C22.36 28.22 22.4534 28.1533 22.5467 28.1C22.8134 27.94 23.08 27.7933 23.3467 27.62C23.44 27.5666 23.52 27.5 23.6134 27.4333C23.88 27.2466 24.1334 27.06 24.3734 26.86C24.4534 26.7933 24.52 26.7266 24.6 26.6733C24.7467 26.5533 24.8934 26.4333 25.0267 26.3133C25.0267 26.3 25.0267 26.3 25.0134 26.2866C27.6667 23.8466 29.3334 20.3666 29.3334 16.5Z"
                fill="white"/>
            <path
                d="M16 9.73956C13.24 9.73956 11 11.9796 11 14.7396C11 17.4462 13.12 19.6462 15.9333 19.7262C15.9733 19.7262 16.0267 19.7262 16.0533 19.7262C16.08 19.7262 16.12 19.7262 16.1467 19.7262C16.16 19.7262 16.1733 19.7262 16.1733 19.7262C18.8667 19.6329 20.9867 17.4462 21 14.7396C21 11.9796 18.76 9.73956 16 9.73956Z"
                fill="white"/>
        </g>
    </svg>
);